import React from "react";
import useNavigationHandeler from "../hooks/useNavigationHandler";
import useHandleOrder from "../hooks/useHandleOrder";
import useGlobalStore from "../stores/globalStore";
import useHandleNAOrder from "../hooks/useHandleNAOrder";

function Navbar({ isPending }) {
  // Form state
  const {
    nameRef,
    addressRef,
    postnumberRef,
    cityRef,
    emailRef,
    phoneRef,

    iAcceptPrivacy,
    iAcceptedTerms,
    isSending,
  } = useGlobalStore((state) => state);

  //Hooks
  const { navigationHandler, activeView, VIEWS } = useNavigationHandeler();
  const handleOrder = useHandleOrder();
  const handleNAOrder = useHandleNAOrder();

  return (
    <nav className="tel-pt-nav">
      <button
        className="tel-pt-nav__button tel-pt-nav__button__prev"
        type="button"
        onClick={() => navigationHandler("prev")}
        disabled={activeView === 1}
      >
        Tillbaka
      </button>
      <h2 className="tel-pt-nav__title">{VIEWS[activeView]}</h2>

      {activeView === 9 || activeView === 0 ? (
        <button
          className="tel-pt-nav__button tel-pt-nav__button__send"
          type="button"
          onClick={(e) => (activeView === 0 ? handleNAOrder(e) : handleOrder())}
          disabled={!nameRef || !addressRef || !postnumberRef || !cityRef || !emailRef || !phoneRef || !iAcceptPrivacy || !iAcceptedTerms || isSending}
        >
          Skicka
        </button>
      ) : (

        <button
          className="tel-pt-nav__button tel-pt-nav__button__next"
          type="button"
          onClick={() => navigationHandler("next")}
          disabled={isPending || isSending}
        >
          Nästa
        </button>
      )}
    </nav>
  );
}

export default Navbar;
